import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiSpecificationsDataDownloadService {

  productsData: Object;
  productsSubject = new Subject<any>();
  productListSubject = new Subject<any>();
  productSwitchSubject = new Subject<any>();

  constructor() { }

  /**
   * 
   * @param data 
   */
   setSpecificationsData(data: any): void {

    this.productsSubject.next(data);
  }

  /**
  * 
  * @param org_id 
  */
  reloadList(org_id: string): void {

    this.productListSubject.next(org_id);
  }

  /**
   * 
   * @param data 
   */
  switchTab(data: boolean): void {

    this.productSwitchSubject.next(data);
  }

  /**
    * Method to listen for language change
    * @returns Observable<any>
    */
  listenerSpecificationsData(): Observable<any> {

    return this.productsSubject.asObservable();
  }

  /**
   * Method to listen for language change
   * @returns Observable<any>
   */
  listenerSpecificationsDataForReload(): Observable<any> {

    return this.productListSubject.asObservable();
  }
  /**
   * Method to listen for language change
   * @returns Observable<any>
   */
  listenerSwitchTab(): Observable<any> {

    return this.productSwitchSubject.asObservable();
  }
}
